import { IDs } from '../../../helpers/IDs';

export function getCustomDataPresetVsme(entity: string, item: any, data: any, filter?: any): any {
    let preset: any = {};
    data = data || {};
    item = item || {};

    switch (entity) {
        case IDs.ENT_VSME_B3:
            return { e_tool_nutzung_orig: 1 }; // {1} Ja, {2} Nein
        case IDs.ENT_VSME_B4:
            return {
                kategorie_luft_orig: 2, // {1} Ja, {2} Nein
                kategorie_wasser_orig: 2, // {1} Ja, {2} Nein
                kategorie_boden_orig: 2 // {1} Ja, {2} Nein
            };
        case IDs.ENT_VSME_B5:
            preset.schutzgebiet_orig =  2; // {1} Ja, {2} Nein
            preset = { ...preset, ...getPresetVsme5(item, data, filter) };
            break;
        case IDs.ENT_VSME_B6:
            return { abwasser_zaehler_orig: 2 }; // {1} Ja, {2} Nein
        case IDs.ENT_VSME_B7:
            return { unternehmensverfahren_orig: 2 }; // {1} Ja, {2} Nein
        case IDs.ENT_VSME_B9:
            return {
                arbeitsunfaelle_orig: 2, // {1} Ja, {2} Nein
                todesfaelle_orig: 2 // {1} Ja, {2} Nein
            };
        case IDs.ENT_VSME_B11:
            return { unternehmensprozesse_orig: 2 }; // {1} Ja, {2} Nein
        case IDs.ENT_VSME_B12:
            return { verurteilungen_geldbussen_orig: 2 }; // {1} Ja, {2} Nein
        case IDs.ENT_VSME_BPM1:
            return {
                umstrittene_waffen_orig: 2, // {1} Ja, {2} Nein
                tabak_orig: 2, // {1} Ja, {2} Nein
                fossile_brennstoffe_orig: 2, // {1} Ja, {2} Nein
                chemikalien_orig: 2 // {1} Ja, {2} Nein
            };
        case IDs.ENT_VSME_BPM3:
            return { ziele_orig: 2 }; // {1} Ja, {2} Nein
        case IDs.ENT_VSME_BPM4:
            return { uebergangsplan_orig: 2 }; // {1} Ja, {2} Nein
        case IDs.ENT_VSME_BPM5:
            return { physikalische_risiken_orig: 2 }; // {1} Ja, {2} Nein
        case IDs.ENT_VSME_BPM6:
            return { gefaehrliche_radioaktive_abfaelle_orig: 2 }; // {1} Ja, {2} Nein
        case IDs.ENT_VSME_BPM7:
            return {
                recht_sicheres_gesundes_arbeitsumfeld_orig: 2, // {1} Ja, {2} Nein
                vereinigungsfreiheit_orig: 2, // {1} Ja, {2} Nein
                recht_tarifverhandlungen_orig: 2, // {1} Ja, {2} Nein
                beseitigung_diskriminierung_orig: 2, // {1} Ja, {2} Nein
                recht_entgelt_arbeit_orig: 2, // {1} Ja, {2} Nein
                keine_kinder_zwangsarbeit_orig: 2, // {1} Ja, {2} Nein
                un_leitprinzipien_orig: 2, // {1} Ja, {2} Nein
                iao_prinzipien_rechte_orig: 2, // {1} Ja, {2} Nein
                oecd_leitsaetze_orig: 2, // {1} Ja, {2} Nein
                schulungen_menschenrechte_orig: 2, // {1} Ja, {2} Nein
                erfassung_lieferketten_orig: 2, // {1} Ja, {2} Nein
                vereinbarungen_leitlinien_orig: 2 // {1} Ja, {2} Nein
            };
        case IDs.ENT_VSME_BPM8:
            return {
                un_leitprinzipien_orig: 2, // {1} Ja, {2} Nein
                iao_prinzipien_rechte_orig: 2, // {1} Ja, {2} Nein
                oecd_leitsaetze_orig: 2, // {1} Ja, {2} Nein
                anzeigemoeglichkeit_menschenrechtsverletzungen_orig: 2, // {1} Ja, {2} Nein
                anzeigemoeglichkeit_arbeitsrechtsverstoesse_orig: 2 // {1} Ja, {2} Nein
            };
        case IDs.ENT_VSME_BPM9:
            return {
                un_leitprinzipien_orig: 2, // {1} Ja, {2} Nein
                iao_prinzipien_rechte_orig: 2, // {1} Ja, {2} Nein
                oecd_leitsaetze_orig: 2 // {1} Ja, {2} Nein
            };
        case IDs.ENT_VSME_N3:
            return { strategien_massnahmen_orig: 2 }; // {1} Ja, {2} Nein
    }

    return preset;
}

function getPresetVsme5(item: any, data: any, filter: any): any {
    const jahr: number = (filter || {}).jahr || null;
    const keys: string[] = [
        'vorjahr_flaeche_nutzung', 'vorjahr_flaeche_versiegelt', 'vorjahr_flaeche_naturnah_standort', 'vorjahr_flaeche_naturnah_ausserhalb'
    ];
    const preset: any = {};
    const prevItem: any = ((data || {})[IDs.ENT_VSME_B5] || []).find((item: any) => typeof jahr === 'number' && item.jahr === jahr - 1);

    if (!prevItem) {
        return {};
    }
    
    keys.forEach((key: string) => {
        const keyJahr: string = key.replace(/^vor/, '');

        if ((item || {})[key] || !prevItem[keyJahr]) {
            return;
        }
        preset[key] = prevItem[keyJahr];
    });

    return preset;
}
